module.exports = __webpack_public_path__ + "pbslm-logo.svg";